// extracted by mini-css-extract-plugin
module.exports = {"brandSecondary":"brand_secondary_button-module__brandSecondary--sMDQz"};